import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {
    selectEasyBankAccountKey,
    selectEasyCardId,
    selectSecondEasyBankAccountKey,
    selectSecondEasyCardId,
    selectSecondWithdrawalAccountKey,
    selectWithdrawalAccountKey,
    startProcess,
    updateMobileNumbers,
    MobilePaymentStatus,
    PriorityPaymentMethodState,
    getInitialState,
} from '@web/slices/priorityPaymentMethod/slice'

import {MakeSliceOptions, PriorityPaymentMethodReducers} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<
        PriorityPaymentMethodState,
        PriorityPaymentMethodReducers,
        'priorityPaymentMethod',
        SliceSelectors<PriorityPaymentMethodState>
    >({
        name: 'priorityPaymentMethod',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(selectWithdrawalAccountKey, (state, {payload}) => {
                state.selectedPayment.chargeAccount.accountKey = payload
            })
            builder.addCase(selectSecondWithdrawalAccountKey, (state, {payload}) => {
                state.selectedSecondPayment.chargeAccount.accountKey = payload
            })
            builder.addCase(selectEasyBankAccountKey, (state, {payload}) => {
                state.selectedPayment.bankEasyPay.accountKey = payload
            })
            builder.addCase(selectSecondEasyBankAccountKey, (state, {payload}) => {
                state.selectedSecondPayment.bankEasyPay.accountKey = payload
            })
            builder.addCase(selectEasyCardId, (state, {payload}) => {
                state.selectedPayment.cardEasyPay.cardId = payload
            })
            builder.addCase(selectSecondEasyCardId, (state, {payload}) => {
                state.selectedSecondPayment.cardEasyPay.cardId = payload
            })
            builder.addCase(updateMobileNumbers, (state, {payload}) => {
                state.selectedPayment.mobile.mobileNumbers = payload
            })
            builder.addCase(startProcess, (state) => {
                state.mobilePaymentStatus = MobilePaymentStatus.PROCESSING
            })
            options?.extraReducers?.(builder)
        },
    })
